<div
  class="image-viewer-backdrop fixed top-0 left-0 w-screen h-screen flex flex-column align-items-center justify-content-center overflow-hidden z-5 bg-black-alpha-90 select-none"
  (click)="onBackdropClick($event)"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="altText"
>
  <button
    type="button"
    class="close-button absolute top-0 right-0 m-3 md:m-4 flex align-items-center justify-content-center cursor-pointer border-circle border-none bg-white-alpha-20 p-2 z-5 transition-duration-150 transition-colors"
    (click)="closeModal(CloseRoleEnum.BUTTON)"
    aria-label="Cerrar visor de imagen"
  >
    <app-icon iconName="x"></app-icon>
  </button>

  <div
    class="image-wrapper relative flex align-items-center justify-content-center w-full h-full p-3 md:p-6 select-none"
    (click)="onContentClick($event)"
  >
    <div
      *ngIf="presenter.status === StatusEnum.LOADING"
      class="spinner-container absolute flex align-items-center justify-content-center z-4"
    >
      <div class="custom-spinner border-circle"></div>
    </div>

    <img
      [src]="presenter.currentImageUrl"
      [alt]="altText"
      class="viewer-image border-round-2xl shadow-6 transition-transform transition-duration-200"
      [class.opacity-0]="presenter.status === StatusEnum.LOADING"
      (load)="onImageLoad()"
      (error)="onImgError($event)"
    />
  </div>
</div>
